import configVars from "../../config";
import {
  UPDATE_BATTERY_LEVEL,
  SET_BATTERY_LEVEL,
  DELETE_BATTERY_LEVEL,
  ADD_BATTERY_LEVEL,
} from "../types";
import { getWithExpiry, setWithExpiry } from "../../common";

export const getBatteryLevelsFromAPi = (token, date, customDates) => {
  return async (dispatch) => {
    const batterLevelsFromBrowserStorage = getWithExpiry(
      "sustainchange_battery_levels"
    );
    if (
      batterLevelsFromBrowserStorage !== null &&
      batterLevelsFromBrowserStorage?.type === date
    ) {
      dispatch({
        type: SET_BATTERY_LEVEL,
        payload: batterLevelsFromBrowserStorage,
      });
    } else {
      const response = await fetch(
        `${configVars.apiUrl}sustainchange/v1/get-battery-levels`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${configVars.auth}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            dateRange: date,
            custom_dates: customDates,
            token: token,
          }),
        }
      );
      const userRecords = await response.json();
      if (userRecords) {
        setWithExpiry("sustainchange_battery_levels", userRecords);
        dispatch({
          type: SET_BATTERY_LEVEL,
          payload: userRecords,
        });
      }
    }
  };
};
export const addEditBatteryLevel = (token, id, remarks, battery_level) => {
  return async (dispatch) => {
    const response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/save-battery-levels`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: token,
          id: id,
          remarks: remarks,
          battery_status: battery_level,
        }),
      }
    );
    if (response) {
      const record_added = await response.json();
      if (id === 0) {
        const addObj = {
          type: record_added?.data?.graph_data?.type,
          today_recent_record:
            record_added?.data?.graph_data?.today_recent_record,
          series: record_added?.data?.graph_data?.series,
          data: record_added?.data?.graph_data?.data,
          categories: record_added?.data?.graph_data?.categories,
          total_records: parseInt( record_added?.data?.graph_data?.total_records, 10 ),
        };
        setWithExpiry("sustainchange_battery_levels", addObj);
        dispatch({
          type: ADD_BATTERY_LEVEL,
          payload: record_added.data,
        });
      } else {
        const updateObj = {
          type: record_added?.data?.graph_data?.type,
          today_recent_record:
            record_added?.data?.graph_data?.today_recent_record,
          series: record_added?.data?.graph_data?.series,
          data: record_added?.data?.graph_data?.data,
          categories: record_added?.data?.graph_data?.categories,
          total_records: parseInt( record_added?.data?.graph_data?.total_records, 10 ),
        };
        setWithExpiry("sustainchange_battery_levels", updateObj);
        dispatch({
          type: UPDATE_BATTERY_LEVEL,
          payload: record_added.data,
        });
      }
    }
  };
};

export const deleteBatteryLevel = (token, id) => {
  return async (dispatch) => {
    const delete_response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/delete-battery-level`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: token,
          id: id,
        }),
      }
    );
    if (delete_response) {
      const record_deleted = await delete_response.json();
      const deleteObj = {
        type: record_deleted?.data?.graph_data?.type,
        today_recent_record:
          record_deleted?.data?.graph_data?.today_recent_record,
        series: record_deleted?.data?.graph_data?.series,
        data: record_deleted?.data?.graph_data?.data,
        categories: record_deleted?.data?.graph_data?.categories,
        total_records: parseInt( record_deleted?.data?.graph_data?.total_records, 10 ),
      };
      setWithExpiry("sustainchange_battery_levels", deleteObj);
      dispatch({
        type: DELETE_BATTERY_LEVEL,
        payload: record_deleted.data,
      });
    }
  };
};
